// Generated by CoffeeScript 1.9.3
(function() {
  var InvalidFilterError;

  InvalidFilterError = require('error-types');

  rjm.model.RestrictionSequence = Backbone.RelationalModel.extend({
    initialize: function(options) {
      if (!options.hasOwnProperty("string")) {
        throw "InvalidContructorArgs - Restriction Sequence";
      }
      _.extend(this, Backbone.Events);
      _.bindAll(this, "mapOverRestrictionsInSyntaxTree", "getIndiciesUsedInTree", "cleanseReferenceToRestrictionByIndex", "updateString", "updateSyntaxTree", "toJSON", "isEmpty", "_isEmptySequenceString", "_isEmptySyntaxTree", "syntaxTreeToString", "_syntaxTreeToString", "equal");
      this.bind("change:syntaxTree", this.updateString);
      this.bind("change:string", this.updateSyntaxTree);
      this.updateSyntaxTree();
      return this.errorMessage = "";
    },
    mapOverRestrictionsInSyntaxTree: function(func, syntaxTree) {
      var newSyntaxTree;
      if (!_(syntaxTree).isObject()) {
        return func(syntaxTree);
      }
      newSyntaxTree = {};
      newSyntaxTree.leftTree = this.mapOverRestrictionsInSyntaxTree(func, syntaxTree.leftTree);
      newSyntaxTree.operation = syntaxTree.operation;
      newSyntaxTree.rightTree = this.mapOverRestrictionsInSyntaxTree(func, syntaxTree.rightTree);
      return newSyntaxTree;
    },
    getIndiciesUsedInTree: function() {
      var _recur;
      _recur = function(syntaxTree) {
        var array;
        if (_(syntaxTree).isNumber()) {
          return [syntaxTree];
        }
        array = [];
        array.push(_recur(syntaxTree.leftTree));
        array.push(_recur(syntaxTree.rightTree));
        return _.flatten(array);
      };
      if (this._isEmptySyntaxTree()) {
        return [];
      } else {
        return _recur(this.get("syntaxTree"));
      }
    },
    cleanseReferenceToRestrictionByIndex: function(indexToDelete) {
      var cleanTreeRecursive, currentTree, newTree, reindexedTree;
      cleanTreeRecursive = function(tree, index) {
        var newSyntaxTree;
        if (_(tree).isNumber()) {
          if (tree === index) {
            return null;
          }
          return tree;
        }
        newSyntaxTree = {};
        newSyntaxTree.leftTree = cleanTreeRecursive(tree.leftTree, index);
        newSyntaxTree.operation = tree.operation;
        newSyntaxTree.rightTree = cleanTreeRecursive(tree.rightTree, index);
        if (_(newSyntaxTree.leftTree).isNull() && _(newSyntaxTree.rightTree).isNull()) {
          return null;
        }
        if (_(newSyntaxTree.leftTree).isNull() && !_(newSyntaxTree.rightTree).isNull()) {
          return newSyntaxTree.rightTree;
        }
        if (!_(newSyntaxTree.leftTree).isNull() && _(newSyntaxTree.rightTree).isNull()) {
          return newSyntaxTree.leftTree;
        }
        return newSyntaxTree;
      };
      if (this.isEmpty()) {
        return;
      }
      currentTree = this.get("syntaxTree");
      newTree = cleanTreeRecursive(currentTree, indexToDelete);
      reindexedTree = this.mapOverRestrictionsInSyntaxTree(function(restrictionIndex) {
        if (restrictionIndex > indexToDelete) {
          return restrictionIndex - 1;
        } else {
          return restrictionIndex;
        }
      }, newTree);
      return this.set({
        syntaxTree: reindexedTree
      }, {
        isTreeMaster: true
      });
    },
    updateString: function(restrictionSequence, syntaxTree, options) {
      if ((options != null ? options.isTreeMaster : void 0) === true) {
        if (this.get('syntaxTree') === null) {
          this.set({
            string: null
          });
        } else {
          this.set({
            string: this._syntaxTreeToString(this.get("syntaxTree"))
          });
        }
      }
      if (this._isEmptySyntaxTree()) {
        return this.set({
          string: null
        });
      } else {
        return this.set({
          string: this._syntaxTreeToString(this.get("syntaxTree"))
        });
      }
    },
    updateSyntaxTree: function() {
      var convertRestrictionLettersToIndex, e, errorMessage, sequenceStringState;
      convertRestrictionLettersToIndex = function(syntaxTree) {
        return this.mapOverRestrictionsInSyntaxTree(encodedLetterString.alphaToIndex, syntaxTree);
      };
      sequenceStringState = this.isValid;
      errorMessage = this.errorMessage;
      try {
        if (this._isEmptySequenceString()) {
          this.set({
            syntaxTree: null
          });
        } else {
          this.set({
            syntaxTree: convertRestrictionLettersToIndex.call(this, rjm.util.sequenceStringParser.parse(this.get("string").toUpperCase()))
          });
        }
        this.isValid = true;
        this.trigger("syntaxTreeUpdated");
      } catch (_error) {
        e = _error;
        if (e instanceof InvalidFilterError) {
          this.errorMessage = e.message;
        } else {
          this.errorMessage = "Invalid filter logic";
        }
        this.isValid = false;
      }
      if (sequenceStringState !== this.isValid || errorMessage !== this.errorMessage) {
        return this.trigger("stringValidChange", this.isValid, this.errorMessage);
      }
    },
    toJSON: function() {
      var r, x;
      r = Backbone.RelationalModel.prototype.toJSON.call(this);
      x = {};
      x.string = r.string;
      return x;
    },
    isEmpty: function() {
      return this._isEmptySequenceString() || this._isEmptySyntaxTree();
    },
    _isEmptySequenceString: function() {
      return _(this.get("string")).isEmpty();
    },
    _isEmptySyntaxTree: function() {
      if (_(this.get("syntaxTree")).isNull() || _(this.get("syntaxTree")).isUndefined()) {
        return true;
      }
      return false;
    },
    syntaxTreeToString: function() {
      return this._syntaxTreeToString(this.get("syntaxTree"));
    },
    _syntaxTreeToString: function(syntaxTree) {
      var string;
      if (syntaxTree === null) {
        return null;
      }
      if (_(syntaxTree).isNumber() || _(syntaxTree.leftTree).isNumber()) {
        syntaxTree = this.mapOverRestrictionsInSyntaxTree(encodedLetterString.indexToAlpha, syntaxTree);
      }
      if (!_(syntaxTree).isObject()) {
        return syntaxTree;
      }
      string = "(";
      string += this._syntaxTreeToString(syntaxTree.leftTree);
      string += " " + syntaxTree.operation + " ";
      string += this._syntaxTreeToString(syntaxTree.rightTree);
      string += ")";
      return string;
    },
    equal: function(sequence) {
      var otherPureString, thisPureString;
      if (sequence == null) {
        return false;
      }
      if (this._isEmptySequenceString() && sequence._isEmptySequenceString()) {
        return true;
      }
      otherPureString = sequence.syntaxTreeToString();
      thisPureString = this.syntaxTreeToString();
      if ((otherPureString != null ? otherPureString.toLowerCase() : void 0) !== (thisPureString != null ? thisPureString.toLowerCase() : void 0)) {
        return false;
      }
      return true;
    }
  });

}).call(this);
